import React from "react";
import { gql, useQuery } from "@apollo/client";
import { withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import { useParams } from "react-router-dom";
import TableLink from "../TableLink";

const styles = theme => ({
  root: {
    marginTop: theme.spacing(3),
    overflowX: "auto",
    margin: "auto"
  },
  table: {
    minWidth: 700
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 300
  }
});

const GET_TOURNAMENT_PLAYERS = gql`
  query playerDetailQuery($id: Int, $playerId: Int) {
    Player(
      id: $playerId
      filter: { teams_some: { tournament: { id: $id } } }
      orderBy: name_asc
    ) {
      id
      name
      teams(filter: { tournament: { id: $id } }) {
        id
        name
      }
      performances(
        filter: { tournament: { id: $id } }
        orderBy: round_number_asc
      ) {
        round_number
        points
        powers
        gets
        negs
        tossups_heard
        opponent {
          id
          name
        }
      }
    }
  }
`;

function PlayerDetail(props) {
  const { id, playerId } = useParams();
  const { classes } = props;

  const { loading, data, error } = useQuery(GET_TOURNAMENT_PLAYERS, {
    variables: {
      id: parseInt(id),
      playerId: parseInt(playerId) || undefined
    }
  });

  return (
    <div className={classes.root}>
      {loading && !error && <p>Loading...</p>}
      {error && !loading && <p>Error</p>}
      {data && !loading && !error && (
        <div>
          {data.Player.map(p => {
            return (
              <React.Fragment key={p.id}>
                <Typography variant="h6" gutterBottom>
                  <TableLink to={`/player/${p.id}`}>{p.name}</TableLink>
                  {", "}
                  <TableLink
                    to={`/tournament/${id}/team-detail/${p.teams[0].id}`}
                  >
                    {p.teams[0].name}
                  </TableLink>
                </Typography>
                <Table className={classes.table} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell key="opponent">Opponent</TableCell>
                      <TableCell key="powers">Powers</TableCell>
                      <TableCell key="gets">Gets</TableCell>
                      <TableCell key="negs">Negs</TableCell>
                      <TableCell key="tossups_heard">Tossups Heard</TableCell>
                      <TableCell key="points">Points</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {p.performances.map((p, k) => {
                      return (
                        <TableRow key={k}>
                          <TableCell component="th" scope="row">
                            <TableLink
                              to={`/tournament/${id}/team-detail/${p.opponent.id}`}
                            >
                              {p.opponent.name}
                            </TableLink>
                          </TableCell>
                          <TableCell>{p.powers}</TableCell>
                          <TableCell>{p.gets}</TableCell>
                          <TableCell>{p.negs}</TableCell>
                          <TableCell>{p.tossups_heard}</TableCell>
                          <TableCell>{p.points}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                <br />
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default withStyles(styles)(PlayerDetail);
